export default {
  // 保存菜单数据
  setMenuList(menuList) {
    sessionStorage.setItem('menuList', JSON.stringify(menuList))
  },

  // 获取菜单数据
  getMenuList() {
    const menuList = sessionStorage.getItem('menuList')
    const parsed = menuList ? JSON.parse(menuList) : []
    // const projectMenu = parsed.find(item =>
    //   Array.isArray(item.list) && item.list.some(child =>
    //     ['projectMan', 'addressMan', 'roomQrCode'].includes(child.path)
    //   )
    // )
    // if (projectMenu && !projectMenu.list.some(child => child.path === 'roomQrCode')) {
    //   projectMenu.list.push({ name: '房间二维码', path: 'roomQrCode', icon: 'el-icon-full-screen' })
    // }
    return parsed
  },

  // 清除菜单数据
  clearMenuList() {
    sessionStorage.removeItem('menuList')
  }
} 
